/* ==========================================================================
   The SoArt — Gift Message form association
   soart-gift-message.js
   --------------------------------------------------------------------------
   Horizon renders theme blocks (price, variant picker, buy-buttons, and this
   gift-message block) as SIBLINGS. The product <form> lives inside the
   buy-buttons block, so a gift-message block placed anywhere else in Product
   Information is OUTSIDE that <form>. Its inputs would therefore be excluded
   from `new FormData(form)` — which is exactly what Horizon submits.

   This script associates the gift inputs with the REAL product form using the
   native HTML `form` attribute (no AJAX, no duplicated form). It finds the form
   at runtime instead of trusting a hardcoded/derived id, so it works wherever
   the merchant positions the block.

   Only global used: window.SOART.
   ========================================================================== */

(function () {
  'use strict';

  var SOART = (window.SOART = window.SOART || {});
  if (SOART.GiftMessage) return;

  var counter = 0;

  /* Locate the product form that this gift block belongs to. */
  function findProductForm(giftEl) {
    /* 1) The form that owns the native Add-to-Cart button (most reliable —
          this is the same button the delivery modal intercepts/replays). */
    var trigger = document.querySelector('[data-soart-delivery-trigger]');
    if (trigger) {
      var triggerForm = trigger.closest('form');
      if (triggerForm) return triggerForm;
    }

    /* 2) A form the block is already inside. */
    var ancestorForm = giftEl.closest('form');
    if (ancestorForm) return ancestorForm;

    /* 3) The nearest /cart/add form by DOM proximity (handles pages with more
          than one product form, e.g. recommendations / quick-add). */
    var forms = Array.prototype.slice.call(
      document.querySelectorAll('form[action*="/cart/add"]')
    );
    if (!forms.length) return null;
    if (forms.length === 1) return forms[0];

    var best = null;
    var bestDepth = Infinity;
    forms.forEach(function (form) {
      var node = giftEl;
      var depth = 0;
      while (node) {
        if (node.contains(form)) {
          if (depth < bestDepth) {
            bestDepth = depth;
            best = form;
          }
          break;
        }
        node = node.parentElement;
        depth++;
      }
    });
    return best || forms[0];
  }

  function ensureId(form) {
    /* Use getAttribute/setAttribute, not form.id: a product form contains an
       <input name="id"> (the variant), which DOM-clobbers the `.id` property
       (it returns that input element instead of the id string). */
    var id = form.getAttribute('id');
    if (!id) {
      id = 'SoartProductForm-' + ++counter;
      form.setAttribute('id', id);
    }
    return id;
  }

  function wire(giftEl) {
    if (giftEl._soartGiftWired) return;

    var fields = giftEl.querySelectorAll('[data-soart-gift-field]');
    if (!fields.length) return;

    var form = findProductForm(giftEl);
    if (!form) return;

    var formId = ensureId(form);
    Array.prototype.forEach.call(fields, function (field) {
      /* Respect an explicit form id passed via Liquid; otherwise associate. */
      if (!field.getAttribute('form')) {
        field.setAttribute('form', formId);
      }
    });

    giftEl._soartGiftWired = true;
  }

  function init() {
    var blocks = document.querySelectorAll('[data-soart-gift]');
    Array.prototype.forEach.call(blocks, wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  SOART.GiftMessage = { init: init };
})();